import { render, staticRenderFns } from "./Stats5.vue?vue&type=template&id=75174e66&"
import script from "./Stats5.vue?vue&type=script&lang=js&"
export * from "./Stats5.vue?vue&type=script&lang=js&"
import style0 from "./Stats5.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports